import "./index.css";
import { useRef, useState, useMemo, useCallback } from "react";
import { useEffect } from "react";
import { ModalAddLocation, ModalCompanyDetail } from "../../components/CompanyComponent";
import {
  getBusinessList,
  getBusinessDetail,
  getFirstBusiness,
  createBusiness,
} from "../../apis/Business/Business";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AccountContext, ContainerBody } from "../../App";
import { createContext, useContext } from "react";
import { YearTabContext } from "../../components/Skeleton";
import { getAccountInfo } from "../../apis/User";
import { useUserAccess } from "../../components/WriteAccessContext";
// import EPRBox from "./EPR";
import CompanyIntro from "./CompanyIntro";
import {
  Building2,
  ChevronLeft,
  ChevronRight,
  CircleDollarSign,
  Home,
  Plus,
  Share2,
} from "lucide-react";
import { getFranchiseList } from "../../apis/Business/FranchiseApi";
import { getEquityInvestmentList } from "../../apis/Business/EquityInvestmentApi";
import { getDebtProjectList } from "../../apis/Business/DebtProjectApi";
import CompanyTabsBar from "./CompanyTabsBar";
import { upsertCompanyTab } from "./useCompanyOpenTabs";
import { useSim } from "./SimContext";
import { SimulatedTiles } from "./SimulatedTiles";
import NewFacilityLovable from "../NewCompany/AddCompany/NewFacilityLovable";
import {
  buildAddressLine1,
  buildCheckedTypesForSingleBuilding,
  defaultOwnershipPercent,
  mapOwnershipToApi,
  parseAccountingPeriodToApiDates,
} from "../NewCompany/AddCompany/addFacilityMappers";

export const DropdownInvestmentContext = createContext();

const RowSection = ({ title, children }) => {
  return (
    <section className="companyLov__rowSection">
      <div className="companyLov__rowPill">{title}</div>
      {children}
    </section>
  );
};

const Carousel = ({ children }) => {
  const ref = useRef(null);
  const scroll = (dir) => {
    const el = ref.current;
    if (!el) return;
    el.scrollBy({ left: dir === "left" ? -320 : 320, behavior: "smooth" });
  };

  return (
    <div className="companyLov__carousel">
      <button
        type="button"
        onClick={() => scroll("left")}
        aria-label="Scroll left"
        className="companyLov__carouselBtn companyLov__carouselBtn--left"
      >
        <ChevronLeft className="h-3.5 w-3.5" />
      </button>
      <div ref={ref} className="companyLov__carouselTrack">
        {children}
      </div>
      <button
        type="button"
        onClick={() => scroll("right")}
        aria-label="Scroll right"
        className="companyLov__carouselBtn companyLov__carouselBtn--right"
      >
        <ChevronRight className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};

const CompanyTile = ({ to, title, subtitle, icon, badge, rightIcon, tab, simGroup }) => {
  const { simMode, onSimulate } = useSim();

  const handleClick = (e) => {
    if (simMode && simGroup) {
      e.preventDefault();
      onSimulate({
        id: String(tab?.id ?? title),
        name: title,
        address: subtitle,
        group: simGroup,
      });
      return;
    }
    if (tab) upsertCompanyTab(tab);
  };

  return (
    <Link
      to={to}
      className={`companyLov__tile${simMode && simGroup ? " companyLov__tile--simMode" : ""}`}
      onClick={handleClick}
    >
      {badge ? <span className="companyLov__tileBadge">{badge}</span> : null}
      <div className="companyLov__tileTitle">{title}</div>
      {subtitle ? <div className="companyLov__tileSubtitle">{subtitle}</div> : null}
      <div className="companyLov__tileFooter">
        <div className="companyLov__tileIconWrap">{icon}</div>
        {rightIcon ? <div className="companyLov__tileRightIcon">{rightIcon}</div> : null}
      </div>
      {simMode && simGroup ? (
        <div className="companyLov__tileSimOverlay" aria-hidden>
          <span className="companyLov__tileSimLabel">Simuler dette</span>
        </div>
      ) : null}
    </Link>
  );
};

const AddTile = ({ to, label, onClick }) => {
  if (typeof onClick === "function") {
    return (
      <button
        type="button"
        className="companyLov__addTile companyLov__addTile--button"
        onClick={onClick}
      >
        <Plus className="h-5 w-5" />
        <span className="companyLov__addTileText">{label}</span>
      </button>
    );
  }
  return (
    <Link to={to} className="companyLov__addTile">
      <Plus className="h-5 w-5" />
      <span className="companyLov__addTileText">{label}</span>
    </Link>
  );
};

const Company = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [locationResponse, setLocationResponse] = useState({});
  const [locations, setLocations] = useState([
    //{
    // "address_line_1":"House no.45 second floor",
    // "address_line_2": "5th cross. Banaswadi",
    // "city" :"Bangalore",
    // "postcode":"560043"}
  ]);
  const yearTab = useContext(YearTabContext);
  const [businessId] = useState("");

  const [addLocation, setAddLocation] = useState(false);
  const [detailLocation, setDetailLocation] = useState(false);
  const [, setCompanyName] = useState("");
  const [, setAddress] = useState("");
  const [activeMainBusinessName, setActiveMainBusinessName] = useState(null);
  const { setUserAccessType, setIsShare } = useUserAccess();
  const urlParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const year = urlParams.get("year");
  const sharedTabParam = urlParams.get("shared");
  const simTabParam = urlParams.get("simTab");
  const [closedSharedTabs, setClosedSharedTabs] = useState([]);
  const [activeLabel, setActiveLabel] = useState(null);
  const businessIdForLists = localStorage.getItem("id_business");

  const [franchiseList, setFranchiseList] = useState([]);
  const [equityList, setEquityList] = useState([]);
  const [debtList, setDebtList] = useState([]);

  const handleToggleActive = (mainBusinessName) => {
    setActiveMainBusinessName(mainBusinessName);
  };

  const [, setBusinessName] = useState("");

  const { setAccount } = useContext(AccountContext);

  const { t } = useTranslation();
  const { simMode } = useSim();

  const [showNewFacilityLovable, setShowNewFacilityLovable] = useState(false);
  const [createStatus, setCreateStatus] = useState(false);
  const [createdBusinessId, setCreatedBusinessId] = useState("");
  const [createErrors, setCreateErrors] = useState({});

  const handleClose = (setter) => {
    document.getElementsByTagName("body")[0].className = "";
    setter(false);
    getBusinessList({ setLocations: setLocations, filterYear: yearTab });
  };

  useEffect(() => {
    if (activeMainBusinessName === null) {
      setUserAccessType("write");
    }
  }, [activeMainBusinessName, setUserAccessType]);

  useEffect(() => {
    if (!sharedTabParam) return;
    if (!locationResponse?.shared?.[sharedTabParam]) return;

    setUserAccessType(
      locationResponse.read_or_write?.[sharedTabParam]?.[0]?.is_write
    );
    setIsShare(true);
    handleToggleActive(sharedTabParam);
    setActiveLabel("external");
  }, [sharedTabParam, locationResponse, setIsShare, setUserAccessType]);

  useEffect(() => {
    if (yearTab) {
      getBusinessList({
        setLocations: setLocations,
        filterYear: yearTab,
        setResponse: setLocationResponse,
      });
      getFirstBusiness({
        setCompanyname: setCompanyName,
        setAddress: setAddress,
      });
      getBusinessDetail({
        id: localStorage.getItem("id_business"),
        setName: setBusinessName,
      });
    } else {
      async function fetchData() {
        // await getBusinessList({
        //   setLocations: setLocations,
        //   setResponse: setLocationResponse,
        // });
        const account = await getAccountInfo();
        setAccount(account.data.data);
      }
      fetchData();
    }
  }, [yearTab, setAccount]);

  useEffect(() => {
    const y = year || yearTab;
    if (!y) return;
    if (!businessIdForLists) return;
    getFranchiseList({ businessId: businessIdForLists, setObjects: setFranchiseList });
    getEquityInvestmentList({ businessId: businessIdForLists, setObjects: setEquityList });
    getDebtProjectList({ businessId: businessIdForLists, setObjects: setDebtList });
  }, [yearTab, year, businessIdForLists]);

  const sortByCountry = useCallback(() => {
    const result = {};
    Array.isArray(locations) &&
      locations.forEach((location) => {
        const splitted = location["address1"]
          ? location["address1"].split(",")
          : [""];

        result[splitted[splitted.length - 1]] = result[
          splitted[splitted.length - 1]
        ]
          ? [...result[splitted[splitted.length - 1]], location]
          : [location];
      });
    return result;
  }, [locations]);

  useEffect(() => {}, [locations]);

  const openTabs = Object.keys(locationResponse?.shared || {})
    .filter((id) => !closedSharedTabs.includes(id))
    .map((id) => ({
      id,
      name: id,
      kind: "external",
    }));

  const activeTabId = simTabParam || activeMainBusinessName || null;

  const handleLovableCreate = useCallback(
    (payload) => {
      const y = year || yearTab;
      const dates = parseAccountingPeriodToApiDates(payload.accountingPeriod);
      const ownershipApi = mapOwnershipToApi(payload.ownership);
      const ownershipPerc = defaultOwnershipPercent(payload.ownership);
      const checked = buildCheckedTypesForSingleBuilding(payload.buildingType, t);
      const typesString = checked
        .filter((row) => row.checked)
        .map((row) => row.name_en)
        .join(",");
      const space_type = checked
        .filter((row) => row.checked)
        .map((row) => ({
          type: row.name_en,
          percentage:
            row.space_percentage == null ? null : Number(row.space_percentage),
        }));
      const address1 =
        payload.address1 ||
        buildAddressLine1({
          street: payload.street,
          city: payload.city,
          postalCode: payload.postalCode,
          country: payload.country,
        });
      const totalSpaceNum =
        String(payload.area || "").trim() === ""
          ? undefined
          : Number(String(payload.area).trim());

      setCreateStatus(false);
      setCreatedBusinessId("");
      setCreateErrors({});

      createBusiness({
        name: String(payload.name || "").trim(),
        address1,
        address2: "",
        country: String(payload.country || "").trim(),
        post_code: String(payload.postalCode || "").trim(),
        baseline: Boolean(payload.baseline),
        status: false,
        setStatus: setCreateStatus,
        setIdBusiness: setCreatedBusinessId,
        yearStart: dates?.yearStart ?? "",
        yearEnd: dates?.yearEnd ?? "",
        type: typesString,
        space_type,
        ownership: ownershipApi,
        ownershipPerc,
        fullTimeEmployees: String(payload.fte ?? "").trim(),
        revenue: String(payload.revenue ?? "").trim(),
        selectedYear: y || undefined,
        total_space:
          totalSpaceNum !== undefined && !Number.isNaN(totalSpaceNum)
            ? totalSpaceNum
            : undefined,
        setErrorMessage: setCreateErrors,
        vat_num: payload.vat_num,
      });
    },
    [t, year, yearTab]
  );

  useEffect(() => {
    if (!createStatus || !createdBusinessId) return;
    setShowNewFacilityLovable(false);
    getBusinessList({ setLocations: setLocations, filterYear: yearTab });
    navigate(`/company/${createdBusinessId}`);
  }, [createStatus, createdBusinessId, navigate, yearTab]);

  // const dropdownInvestment = [
  //     {id:1,name:"Subsidiary (own +50%)",value:"Subsidiary (own +50%)"},
  //     {id:2,name:"Associate company (own 20-50%)",value:"Associate company (own 20-50%)"},
  //     {id:3,name:"Joint Venture",value:"Joint Venture"},
  //     {id:4,name:"Under 20% Ownership",value:"Under 20% Ownership"},
  // ]

  const [, setDropdownInvestment] = useState([
    {
      id: 1,
      name: t("Subsidiary (own +50%)"),
      value: t("Subsidiary (own +50%)"),
    },
    {
      id: 2,
      name: t("Associate company (own 20-50%)"),
      value: t("Associate company (own 20-50%)"),
    },
    { id: 3, name: t("Joint Venture"), value: t("Joint Venture") },
    { id: 4, name: t("Under 20% Ownership"), value: t("Under 20% Ownership") },
  ]);

  useEffect(() => {
    setDropdownInvestment([
      {
        id: 1,
        name: t("Subsidiary (own +50%)"),
        value: t("Subsidiary (own +50%)"),
      },
      {
        id: 2,
        name: t("Associate company (own 20-50%)"),
        value: t("Associate company (own 20-50%)"),
      },
      { id: 3, name: t("Joint Venture"), value: t("Joint Venture") },
      {
        id: 4,
        name: t("Under 20% Ownership"),
        value: t("Under 20% Ownership"),
      },
    ]);
  }, [t]);

  return (
    // <Skeleton
    // content={

    <>
      {addLocation ? (
        <ModalAddLocation
          locations={locations}
          setLocations={setLocations}
          closeModal={() => handleClose(setAddLocation)}
        />
      ) : null}
      {detailLocation ? (
        <ModalCompanyDetail
          businessId={businessId}
          closeModal={() => handleClose(setDetailLocation)}
        />
      ) : null}
      {addLocation ? (
        <div
          className="background__modal"
          onClick={() => handleClose(setAddLocation)}
        ></div>
      ) : null}
      {detailLocation ? (
        <div
          className="background__modal"
          onClick={() => handleClose(setDetailLocation)}
        ></div>
      ) : null}

      <ContainerBody className="company__body">
        {/* <div className="company__body__extrainfo">
                <img src={mark} alt="" />
                <h4>This mark indicates that your product information has ben fully filled in</h4>
            </div> */}
        <div className="company__body__items">
          <CompanyTabsBar activeTabId={activeTabId} />
          <CompanyIntro onSelectLabel={setActiveLabel} />
          {/*
            ERP import flow has been moved to the Company Detail page import modal.
            (Keeps the catalogue page focused on browsing companies.)
          */}
          {/* <EPRBox /> */}

          <div
            className="companyLov__sections"
            data-company-catalog-sim-root
            data-sim-mode={simMode ? "true" : "false"}
          >
            {activeLabel === "external" ? (
              <RowSection title="External">
                <Carousel>
                  {(openTabs || []).map((tab) => {
                    const isWrite = Boolean(
                      locationResponse.read_or_write?.[tab.id]?.[0]?.is_write
                    );
                    const badge = isWrite ? "R/W" : "R";
                    return (
                      <CompanyTile
                        key={tab.id}
                        to={`/company?shared=${encodeURIComponent(tab.id)}`}
                        title={tab.name}
                        subtitle={"Shared company"}
                        badge={badge}
                        icon={<Share2 className="h-6 w-6" />}
                        simGroup="External"
                        tab={{
                          id: tab.id,
                          name: tab.name,
                          kind: "external",
                          to: `/company?shared=${encodeURIComponent(tab.id)}`,
                        }}
                      />
                    );
                  })}
                </Carousel>
              </RowSection>
            ) : null}

            {!activeLabel ? (
              <>
                <RowSection title="Facility">
                  <Carousel>
                    {(locations || []).map((loc) => (
                      <CompanyTile
                        key={loc.id}
                        to={`/company/${loc.id}`}
                        title={loc.name}
                        subtitle={[loc.address1, loc.address2, loc.country, loc.post_code]
                          .filter(Boolean)
                          .join(", ")}
                        icon={<Home className="h-6 w-6" />}
                        simGroup="Facility"
                        tab={{
                          id: loc.id,
                          name: loc.name,
                          kind: "facility",
                          to: `/company/${loc.id}`,
                        }}
                      />
                    ))}
                    <SimulatedTiles group="Facility" />
                    <AddTile
                      onClick={() => setShowNewFacilityLovable(true)}
                      label="Add Facility"
                    />
                  </Carousel>
                </RowSection>

                <RowSection title="Franchise">
                  <Carousel>
                    {(franchiseList || []).map((f) => (
                      <CompanyTile
                        key={f.id}
                        to={`/company/franchise/${f.id}?year=${encodeURIComponent(
                          year || yearTab || ""
                        )}`}
                        title={f.name}
                        subtitle={f.floor_space ? `${f.floor_space}` : ""}
                        icon={<Building2 className="h-6 w-6" />}
                        simGroup="Franchise"
                        tab={{
                          id: f.id,
                          name: f.name,
                          kind: "franchise",
                          to: `/company/franchise/${f.id}?year=${encodeURIComponent(
                            year || yearTab || ""
                          )}`,
                        }}
                      />
                    ))}
                    <SimulatedTiles group="Franchise" />
                    <AddTile
                      to={`/company/add-franchise?year=${encodeURIComponent(
                        year || yearTab || ""
                      )}`}
                      label="Add Franchise"
                    />
                  </Carousel>
                </RowSection>

                <RowSection title="Investment">
                  <Carousel>
                    {(equityList || []).map((inv) => (
                      <CompanyTile
                        key={`eq-${inv.id}`}
                        to={`/company/equity/${inv.id}?year=${encodeURIComponent(
                          year || yearTab || ""
                        )}`}
                        title={inv.investee_name}
                        subtitle={inv.invesment_type ? `${inv.invesment_type}` : ""}
                        icon={<CircleDollarSign className="h-6 w-6" />}
                        simGroup="Investment"
                        tab={{
                          id: `equity-${inv.id}`,
                          name: inv.investee_name,
                          kind: "investment",
                          to: `/company/equity/${inv.id}?year=${encodeURIComponent(
                            year || yearTab || ""
                          )}`,
                        }}
                      />
                    ))}
                    {(debtList || []).map((inv) => (
                      <CompanyTile
                        key={`debt-${inv.id}`}
                        to={`/company/debt/${inv.id}?year=${encodeURIComponent(
                          year || yearTab || ""
                        )}`}
                        title={inv.investee_name}
                        subtitle={inv.invesment_type ? `${inv.invesment_type}` : ""}
                        icon={<CircleDollarSign className="h-6 w-6" />}
                        simGroup="Investment"
                        tab={{
                          id: `debt-${inv.id}`,
                          name: inv.investee_name,
                          kind: "investment",
                          to: `/company/debt/${inv.id}?year=${encodeURIComponent(
                            year || yearTab || ""
                          )}`,
                        }}
                      />
                    ))}
                    <SimulatedTiles group="Investment" />
                    <AddTile
                      to={`/company/add-equity?year=${encodeURIComponent(
                        year || yearTab || ""
                      )}`}
                      label="Add Investment"
                    />
                  </Carousel>
                </RowSection>
              </>
            ) : null}

            {activeLabel === "facility" ? (
              <div className="companyLov__stack">
                {Object.entries(sortByCountry()).map(([country, list], countryIdx) => (
                  <RowSection key={country} title={`Facility — Country: ${country}`}>
                    <div className="companyLov__wrap">
                      {list.map((loc) => (
                        <CompanyTile
                          key={loc.id}
                          to={`/company/${loc.id}`}
                          title={loc.name}
                          subtitle={[loc.address1, loc.address2, loc.country, loc.post_code]
                            .filter(Boolean)
                            .join(", ")}
                          icon={<Home className="h-6 w-6" />}
                          simGroup="Facility"
                          tab={{
                            id: loc.id,
                            name: loc.name,
                            kind: "facility",
                            to: `/company/${loc.id}`,
                          }}
                        />
                      ))}
                      {countryIdx === 0 ? <SimulatedTiles group="Facility" /> : null}
                      <AddTile
                        onClick={() => setShowNewFacilityLovable(true)}
                        label="Add Facility"
                      />
                    </div>
                  </RowSection>
                ))}
              </div>
            ) : null}

            {activeLabel === "franchise" ? (
              <RowSection title="Franchise">
                <div className="companyLov__wrap">
                  {(franchiseList || []).map((f) => (
                    <CompanyTile
                      key={f.id}
                      to={`/company/franchise/${f.id}?year=${encodeURIComponent(
                        year || yearTab || ""
                      )}`}
                      title={f.name}
                      subtitle={f.floor_space ? `${f.floor_space}` : ""}
                      icon={<Building2 className="h-6 w-6" />}
                      simGroup="Franchise"
                      tab={{
                        id: f.id,
                        name: f.name,
                        kind: "franchise",
                        to: `/company/franchise/${f.id}?year=${encodeURIComponent(
                          year || yearTab || ""
                        )}`,
                      }}
                    />
                  ))}
                  <SimulatedTiles group="Franchise" />
                  <AddTile
                    to={`/company/add-franchise?year=${encodeURIComponent(
                      year || yearTab || ""
                    )}`}
                    label="Add Franchise"
                  />
                </div>
              </RowSection>
            ) : null}

            {activeLabel === "investment" ? (
              <div className="companyLov__stack">
                <RowSection title="Investment — Equity">
                  <div className="companyLov__wrap">
                    {(equityList || []).map((inv) => (
                      <CompanyTile
                        key={inv.id}
                        to={`/company/equity/${inv.id}?year=${encodeURIComponent(
                          year || yearTab || ""
                        )}`}
                        title={inv.investee_name}
                        subtitle={inv.invesment_type ? `${inv.invesment_type}` : ""}
                        icon={<CircleDollarSign className="h-6 w-6" />}
                        simGroup="Investment"
                        tab={{
                          id: `equity-${inv.id}`,
                          name: inv.investee_name,
                          kind: "investment",
                          to: `/company/equity/${inv.id}?year=${encodeURIComponent(
                            year || yearTab || ""
                          )}`,
                        }}
                      />
                    ))}
                    <AddTile
                      to={`/company/add-equity?year=${encodeURIComponent(
                        year || yearTab || ""
                      )}`}
                      label="Add Equity Investment"
                    />
                  </div>
                </RowSection>
                <RowSection title="Investment — Debt and Project finance">
                  <div className="companyLov__wrap">
                    {(debtList || []).map((inv) => (
                      <CompanyTile
                        key={inv.id}
                        to={`/company/debt/${inv.id}?year=${encodeURIComponent(
                          year || yearTab || ""
                        )}`}
                        title={inv.investee_name}
                        subtitle={inv.invesment_type ? `${inv.invesment_type}` : ""}
                        icon={<CircleDollarSign className="h-6 w-6" />}
                        simGroup="Investment"
                        tab={{
                          id: `debt-${inv.id}`,
                          name: inv.investee_name,
                          kind: "investment",
                          to: `/company/debt/${inv.id}?year=${encodeURIComponent(
                            year || yearTab || ""
                          )}`,
                        }}
                      />
                    ))}
                    <SimulatedTiles group="Investment" />
                    <AddTile
                      to={`/company/add-debt?year=${encodeURIComponent(
                        year || yearTab || ""
                      )}`}
                      label="Add Debt investment and Project finance"
                    />
                  </div>
                </RowSection>
              </div>
            ) : null}
          </div>
        </div>
      </ContainerBody>

      {showNewFacilityLovable ? (
        <NewFacilityLovable
          onSave={handleLovableCreate}
          onCancel={() => setShowNewFacilityLovable(false)}
        />
      ) : null}

      {Object.keys(createErrors || {}).length > 0 ? (
        <div
          className="fixed bottom-4 left-4 right-4 z-[2100] rounded-md border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800"
          role="alert"
        >
          {Object.entries(createErrors).map(([key, messages]) => (
            <div key={key}>
              {Array.isArray(messages) ? messages.join(" ") : String(messages)}
            </div>
          ))}
        </div>
      ) : null}
    </>
    // }
    // />
  );
};
export default Company;
